import { HSComponent } from "./component.js";
import * as Logger from "./logger.js";
import styles from "./page.css";
import template from "./page.html";
import { HSHeader } from "./header.js";
import { HSGrid } from "./grid.js";
import { HSGridStack } from "./gridstack.js";
import { HSStaticGrid } from "./staticgrid.js";
import { UserSession } from "./session.js";

export class HSPage extends HSComponent {
    #gridstack;

    constructor() {
        super();
    }

    onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
    }

    init(config) {
        super.init(config);

        this.id = config.id;

        const header = this.shadowRoot.querySelector("hs-header");
        header.init();

        this.loadGrid();
    }

    toggleEditMode(enabled) {
        // we reload the main grid content with either gridstack or staticgrid when toggling eidt mode
        super.toggleEditMode(enabled);
        this.loadGrid();
    }

    async reloadData() {
        // tell the grid to reload it's data
        await this.gridstack.reloadData();
        // tell any other components we manage in our own shadowRoot DOM to reload their data
        const components = this.findChildren({
            predicate: (child) => child instanceof HSComponent && !(child instanceof HSGrid),
            shadowOnly: true,
        });
        for (const component of components) {
            if (typeof component.reloadData === "function") {
                component.reloadData();
            }
        }
    }

    loadGrid() {
        if (this.gridstack) {
            this.gridstack.destroy();
            this.gridstack.remove();
            this.gridstack = null;
        }
        if (this.editMode) {
            this.gridstack = document.createElement("hs-gridstack");
        } else {
            this.gridstack = document.createElement("hs-staticgrid");
        }
        this.gridstack.editMode = this.editMode;
        this.appendChild(this.gridstack);
        this.gridstack.init(this.config);
    }

    saveConfig() {
        // get our page gridstack and collect all configs from it's contents
        const grid = this.shadowRoot.querySelector("hs-gridstack");
        if (grid) {
            return { ...this.config, ...grid.saveConfig() };
        } else {
            throw new Error("gridstack not found when trying to save page");
        }
    }
}
customElements.define("hs-page", HSPage);
